module.exports = __webpack_public_path__ + "286d6129e148a118ff08b594102ec5e7.svg";